import React from 'react';

import CloseChat from './CloseChat';
import { activeModalSelector } from '../../store/selectors/modals';
import { useAppSelector } from '../../store/hooks';
import { CLOSE_MODAL, FEEDBACK_MODAL } from '../../constants/modals';
import FeedbackChat from './FeedbackChat';

const Modals = () => {
  const activeModal = useAppSelector(activeModalSelector);
  if (activeModal === CLOSE_MODAL) return <CloseChat />;
  if (activeModal === FEEDBACK_MODAL) return <FeedbackChat />;

  return null;
};

export default Modals;
